<script>
import TwProfileAvatar from './TwProfileAvatar';

export default {
  components: {
    TwProfileAvatar,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    initials: {
      type: String,
      default: null,
    },
  },
};
</script>

<template>
  <v-toolbar flat class="transparent">
    <v-list class="pa-0">
      <v-list-tile avatar>
        <tw-profile-avatar
          :initials="initials"
          :name="name"/>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ name }}
          </v-list-tile-title>
          <v-list-tile-sub-title>
            {{ email }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-toolbar>
</template>



// WEBPACK FOOTER //
// src/components/TwNavigationProfile.vue